import React, { useEffect, useRef, useState } from 'react';

const MultiSelectDropdown = ({
  id,
  label,
  options,
  selectedValues,
  onToggle,
  isOpen,
  onToggleOpen
}) => (
  <div className="relative">
    <button
      type="button"
      onClick={() => onToggleOpen(id)}
      className="cursor-pointer list-none select-none px-3 py-1.5 rounded-md text-xs font-semibold transition-colors" style={{border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.65)',background:'var(--tqa-surface-2)'}}
    >
      {label}
      {selectedValues.length > 0 && (
        <span className="ml-2 text-[11px]" style={{color:'rgba(255,255,255,0.4)'}}>({selectedValues.length})</span>
      )}
    </button>
    {isOpen && (
      <div className="absolute z-10 mt-2 w-64 rounded-lg shadow-xl p-2 max-h-64 overflow-y-auto" style={{border:'1px solid var(--tqa-border-dark)',background:'var(--tqa-surface-3)'}}>
        {options.length === 0 ? (
          <div className="text-xs px-2 py-3" style={{color:'rgba(255,255,255,0.4)'}}>No options available</div>
        ) : (
          options.map((option) => (
            <label key={option.value} className="flex items-center gap-2 text-xs px-2 py-1.5 rounded cursor-pointer" style={{color:'rgba(255,255,255,0.65)'}} onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.06)'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
              <input
                type="checkbox"
                className="rounded border-slate-300"
                checked={selectedValues.includes(option.value)}
                onChange={() => onToggle(option.value)}
              />
              <span className="flex-1 truncate">{option.label}</span>
              <span className="text-[11px]" style={{color:'rgba(255,255,255,0.35)'}}>{option.count}</span>
            </label>
          ))
        )}
      </div>
    )}
  </div>
);

const AnalyzerFilterBar = ({
  severityOptions,
  activeSeverities,
  onSelectSeverity,
  categoryOptions,
  activeCategories,
  onToggleCategory,
  fileOptions,
  activeFiles,
  onToggleFile,
  searchTerm,
  onSearchChange,
  groupBy,
  onGroupByChange,
  onClearFilters,
  activeFilterCount,
  onExport
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggleOpen = (id) => {
    setOpenDropdown((prev) => (prev === id ? null : id));
  };

  return (
    <div ref={containerRef} className="rounded-xl p-4 space-y-3" style={{border:'1px solid var(--tqa-border-dark)',background:'var(--tqa-surface)'}}>
      <div className="flex flex-wrap items-center gap-3">
        <MultiSelectDropdown
          id="severity"
          label="Severity"
          options={severityOptions}
          selectedValues={activeSeverities}
          onToggle={onSelectSeverity}
          isOpen={openDropdown === 'severity'}
          onToggleOpen={handleToggleOpen}
        />
        <MultiSelectDropdown
          id="categories"
          label="Categories"
          options={categoryOptions}
          selectedValues={activeCategories}
          onToggle={onToggleCategory}
          isOpen={openDropdown === 'categories'}
          onToggleOpen={handleToggleOpen}
        />
        <MultiSelectDropdown
          id="files"
          label="Files"
          options={fileOptions}
          selectedValues={activeFiles}
          onToggle={onToggleFile}
          isOpen={openDropdown === 'files'}
          onToggleOpen={handleToggleOpen}
        />
      <div className="flex-1 min-w-[220px]">
        <input
          type="text"
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search description, item, or error code"
          className="w-full rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-tqa-accent/30" style={{border:'1px solid var(--tqa-border-dark)',background:'var(--tqa-surface-2)',color:'rgba(255,255,255,0.85)'}}
        />
      </div>
      <div className="flex items-center gap-2">
        <label className="text-xs" style={{color:'rgba(255,255,255,0.45)'}}>Group by</label>
        <select
          value={groupBy}
          onChange={(event) => onGroupByChange(event.target.value)}
          className="rounded-md px-2 py-1.5 text-sm" style={{border:'1px solid var(--tqa-border-dark)',background:'var(--tqa-surface-2)',color:'rgba(255,255,255,0.8)'}}
        >
          <option value="none">None</option>
          <option value="severity">Severity</option>
          <option value="category">Category</option>
          <option value="file">File</option>
        </select>
      </div>
      <button
        type="button"
        onClick={onExport}
        className="px-3 py-1.5 rounded-md text-xs font-semibold transition-colors" style={{border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.65)',background:'var(--tqa-surface-2)'}}
      >
        Export CSV
      </button>
      {activeFilterCount > 0 && (
        <button
          type="button"
          onClick={onClearFilters}
          className="px-3 py-1.5 rounded-md border border-rose-500/40 text-xs font-semibold text-rose-400 hover:border-rose-400/60 transition-colors"
        >
          Clear all ({activeFilterCount})
        </button>
      )}
      </div>
    </div>
  );
};

export default AnalyzerFilterBar;
